import { render, staticRenderFns } from "./CopyrightSlideBtn.vue?vue&type=template&id=0817dbb6&scoped=true&"
import script from "./CopyrightSlideBtn.vue?vue&type=script&lang=js&"
export * from "./CopyrightSlideBtn.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightSlideBtn.vue?vue&type=style&index=0&id=0817dbb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0817dbb6",
  null
  
)

export default component.exports